import { Link } from 'react-router-dom';
import type { GameId } from '../games';
import GameShell from './GameShell';

/**
 * `gameId` matters more than it looks: without it a failed puzzle fetch would
 * replace the whole page, including the evergreen copy that is the only thing
 * on a game page worth indexing. Crawlers run the app, so a bad minute for the
 * schedule API would otherwise look like a page with no content on it.
 */
export default function ErrorScreen({ message, gameId }: { message: string; gameId?: GameId }) {
  const card = (
    <div style={{ display: 'grid', placeItems: 'center', padding: '48px 20px' }}>
      <div
        className="card"
        style={{
          textAlign: 'center',
          maxWidth: 420,
          borderTop: '4px solid var(--error)',
        }}
      >
        <div style={{ fontSize: 28, marginBottom: 8 }}>⚠️</div>
        <div style={{ fontWeight: 800, marginBottom: 6 }}>Something went wrong</div>
        <div style={{ color: 'var(--text-secondary)', fontSize: 14, marginBottom: 16 }}>
          {message}
        </div>
        <Link to="/" className="btn btn-secondary">
          Back to games
        </Link>
      </div>
    </div>
  );

  return gameId ? <GameShell gameId={gameId}>{card}</GameShell> : card;
}
